import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private sessionExpiredSource = new Subject<void>();
  sessionExpired$ = this.sessionExpiredSource.asObservable();

  constructor(private router: Router) {}

  triggerSessionExpired(): void {
    this.sessionExpiredSource.next();
  }

  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiry = payload.exp * 1000;
      return Date.now() >= expiry;
    } catch (e) {
      return true;
    }
  }

  getToken(): string {
    return (
      sessionStorage.getItem('authToken') ||
      sessionStorage.getItem('token') ||
      localStorage.getItem('authToken') ||
      localStorage.getItem('token') ||
      localStorage.getItem('_act_ls') ||
      localStorage.getItem('access_token') || ''
    );
  }

  clearSession(): void {
    ['authToken', 'token', '_act_ls', 'access_token'].forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    localStorage.removeItem('admissionFormData');
  }

  redirectToLogin(router: Router): void {
    this.clearSession();
    router.navigate(['/main-applcation-login']);
  }
}